import { render, staticRenderFns } from "./DescribeBlock.vue?vue&type=template&id=21ef64c5"
import script from "./DescribeBlock.vue?vue&type=script&lang=js"
export * from "./DescribeBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports